export class AHRTerms {
    public static terms = [
        {id: null, name:"N/A"},
        {id: 1, name:"1st Term"},
        {id: 2, name:"2nd Term"},
        {id: 3, name:"3rd Term"},
        {id: 4, name:"Indefinite Status"}
    ]
}